import { render } from "./ProfileUpdate.vue?vue&type=template&id=f0359808&scoped=true"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js"

import "./ProfileUpdate.vue?vue&type=style&index=0&id=f0359808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0359808"]])

export default __exports__